import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function Members() {
  const [members, setMembers] = useState([]);
  useEffect(() => { api.get("/members").then((r) => setMembers(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <p className="eyebrow text-[#e0481f] text-sm mb-2">Different Trails. Same Family.</p>
      <h1 className="headline text-5xl sm:text-6xl text-[#f7f3ec] mb-3">The Ryders</h1>
      <p className="text-[#a9a196] mb-10 max-w-2xl">Meet the members of the I-65 Ryders family. Every rider has their own profile and ticket link.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
        {members.map((m) => (
          <Link key={m.id} to={`/members/${m.ref_code}`} className="group card-warm rounded-2xl overflow-hidden" data-testid={`member-card-${m.ref_code}`}>
            <div className="h-52 sm:h-64 overflow-hidden bg-[#221f1c]">
              {m.photo ? <img src={m.photo} alt={m.nickname} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /> : <div className="w-full h-full flex items-center justify-center"><Logo className="h-20 opacity-40" /></div>}
            </div>
            <div className="p-4">
              <h3 className="headline text-xl text-[#f7f3ec]">{m.nickname}</h3>
              <p className="text-[#d4af37] text-sm">{m.rides}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
